import action from '../helpers/rest-client'
import { paginationString } from '../helpers/getPaginationString'
import {
  NewCustomerOutDto,
  EditCustomerOutDto,
  DeleteCustomerOutDto,
  GetOneCustomerOutDto,
  GetAllCustomersOutDto,
} from '../types/customer.dto'

const path = '/customer'

class Customer {
  public new(payload: NewCustomerOutDto) {
    return action
      .Post({
        url: `${path}`,
        body: payload,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public edit({ idCustomer, ...rest }: EditCustomerOutDto) {
    console.log(rest.body)
    return action
      .Patch({
        url: `${path}/${idCustomer}`,
        body: rest.body,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }


  public getAll({ filters, pagination, sort, group }: GetAllCustomersOutDto) {
    const filtersJSON = filters ? `&filters=${JSON.stringify(filters)}` : '';
    return action
      .Get({
        url: `${path}/paginated/${paginationString({ pagination, sort, group })}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getOne({ idCustomer }: GetOneCustomerOutDto) {
    return action
      .Get({
        url: `${path}/${idCustomer}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public deleteOne({ idCustomer }: DeleteCustomerOutDto) {
    return action
      .Get({
        url: `${path}/${idCustomer}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const customer = new Customer()
export default customer
